// @ts-nocheck
import * as React from "react";
import Stack from "molecules/stack/stack";
import StackItem from "molecules/stackItem/stackItem";
import moment from "moment";
import MasterDataListItem from "molecules/masterDataList/masterDataListItem";
import { OPTION_IDENTIFIERS } from "./constants";
import { useNavigate } from "react-router-dom";
import Scrollable from "atoms/scrollable/scrollable";
import { useSelector } from "react-redux";
import { getTileOperations } from "./selector";
import { Typography, Input } from "antd";
import { SearchOutlined } from "@ant-design/icons";

const { Title } = Typography;

export type OptionTypes = {
  title: string;
  description: string;
  buttonText: string;
  itemIdentifier: string;
};
const today = moment().format("MM/DD/YYYY");

const MasterData: React.FunctionComponent = () => {
  const navigate = useNavigate();
  const tileOptions = useSelector(getTileOperations);
  const [query, setQuery] = React.useState("");
  const visiableItems = tileOptions
    ?.filter((el) => el.title.toLowerCase().includes(query.toLowerCase()))
    ?.sort((el1, el2) => el1.title.localeCompare(el2.title));
  const handleMasterDataButtonClick = (itemIdentifier: string) => {
    switch (itemIdentifier) {
      case OPTION_IDENTIFIERS.SCHEDULES:
        return navigate("/masterdata/storeschedules");
      case OPTION_IDENTIFIERS.SHIPMENTS:
        return navigate("/masterdata/shipments");
      case OPTION_IDENTIFIERS.SHIPPING_METHOD:
        return navigate("/masterdata/shipmethods");
      case OPTION_IDENTIFIERS.STORE_ORDERS_LIST:
        return navigate("/masterdata/store/order/list");
      case OPTION_IDENTIFIERS.STORES:
        return navigate("/masterdata/stores");
      case OPTION_IDENTIFIERS.VALID_SKU_COMBINATIONS:
        return navigate("/masterdata/skuitemmapping");
      case OPTION_IDENTIFIERS.KITS:
        return navigate("/masterdata/kits");
      case OPTION_IDENTIFIERS.INVENTORY_TRANSACTIONS:
        return navigate("/masterdata/transactions");
      case OPTION_IDENTIFIERS.CUSTOMERS:
        return navigate("/masterdata/customers");
      case OPTION_IDENTIFIERS.SKUS:
        return navigate("/masterdata/skus");
      case OPTION_IDENTIFIERS.VALID_STORE_COMBINATIONS:
        return navigate("/masterdata/storesku");
      case OPTION_IDENTIFIERS.PRIMARY_STORE_SKU:
        return navigate("/masterdata/primaryStoreSku");
      // case OPTION_IDENTIFIERS.SKU_SHIPPING_METHOD_CONFIGURATION:
      // 	return navigate('/masterdata/shipmethodskuconfig');
      case OPTION_IDENTIFIERS.SKU_EXCLUSIONS:
        return navigate("/masterdata/excludestoresku");
      case OPTION_IDENTIFIERS.PRICING:
        return navigate("/masterdata/storeskucost");
      case OPTION_IDENTIFIERS.PARAMETERS:
        return navigate("/masterdata/parameterview");
      case OPTION_IDENTIFIERS.ITEMS:
        return navigate("/masterdata/items");
      case OPTION_IDENTIFIERS.ITEM_SHIPPING_METHOD_CONFIGURATION:
        return navigate("/masterdata/shipmethoditemconfig");
      case OPTION_IDENTIFIERS.ITEM_EXCLUSIONS:
        return navigate("/masterdata/excludestoreitem");
      case OPTION_IDENTIFIERS.AD_TYPES:
        return navigate("/masterdata/adTypes");
      case OPTION_IDENTIFIERS.GROUPS:
        return navigate("/masterdata/groups");
      case OPTION_IDENTIFIERS.WAREHOUSES:
        return navigate("/masterdata/warehouses");
      case OPTION_IDENTIFIERS.PRESENTATION_QUANTITY:
        return navigate("/masterdata/presentation-quantity");
      case OPTION_IDENTIFIERS.RETAIL_SALES:
        return navigate("/masterdata/retail-sales");
      default:
        return;
    }
  };

  const getDisabledStatus = (itemIdentifier: string) => {
    switch (itemIdentifier) {
      case OPTION_IDENTIFIERS.SCHEDULES:
      case OPTION_IDENTIFIERS.SHIPMENTS:
      case OPTION_IDENTIFIERS.SHIPPING_METHOD:
      case OPTION_IDENTIFIERS.STORE_ORDERS_LIST:
      case OPTION_IDENTIFIERS.STORES:
      case OPTION_IDENTIFIERS.VALID_SKU_COMBINATIONS:
      case OPTION_IDENTIFIERS.KITS:
      case OPTION_IDENTIFIERS.INVENTORY_TRANSACTIONS:
      case OPTION_IDENTIFIERS.CUSTOMERS:
      case OPTION_IDENTIFIERS.SKUS:
      case OPTION_IDENTIFIERS.VALID_STORE_COMBINATIONS:
      // case OPTION_IDENTIFIERS.SKU_SHIPPING_METHOD_CONFIGURATION:
      case OPTION_IDENTIFIERS.SKU_EXCLUSIONS:
      case OPTION_IDENTIFIERS.PRICING:
      case OPTION_IDENTIFIERS.PARAMETERS:
      case OPTION_IDENTIFIERS.ITEMS:
      case OPTION_IDENTIFIERS.ITEM_SHIPPING_METHOD_CONFIGURATION:
      case OPTION_IDENTIFIERS.ITEM_EXCLUSIONS:
      case OPTION_IDENTIFIERS.AD_TYPES:
      case OPTION_IDENTIFIERS.GROUPS:
        return false;
      default:
        return true;
    }
  };

  return (
    <Stack className="master-data-wrapper">
      <Stack isVertical gutter="small">
        <StackItem className="content-head">
          <Stack align="space-between" gutter="small">
            <StackItem className="master-data-title">
              <Title level={4}>UPDATED {today}</Title>
            </StackItem>
            <StackItem className="master-data-title">
              <Input
                suffix={<SearchOutlined />}
                placeholder="Search..."
                onChange={(e) => setQuery(e.target.value || "")}
                onSearch={(value) => setQuery(value)}
              />
            </StackItem>
          </Stack>
        </StackItem>
        <Scrollable>
          <Stack isWrap gutter="medium" className={query ? "master-data-items search-card" : "master-data-items"}>
            {visiableItems?.map((option) => {
              return (
                <div className="master-data-item" key={option.itemIdentifier}>
                  <MasterDataListItem
                    title={option.title}
                    description={option.description}
                    buttonText={option.buttonText}
                    handleButtonClick={handleMasterDataButtonClick}
                    itemIdentifier={option.itemIdentifier}
                    disabled={getDisabledStatus(option.itemIdentifier)}
                  />
                </div>
              );
            })}

            {/* </InfiniteScroll> */}
          </Stack>
        </Scrollable>
      </Stack>
    </Stack>
  );
};
export default MasterData;
